import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import useDrawer from "../../contexts/Drawer";
import { useAppSelector } from "../../store";
import UserAvatar from "./UserAvatar";
import DrawerMenu from "../Menu/DrawerMenu";

const StyledDrawer = styled(MuiDrawer)(({ open, theme }) => ({
  height: "100%",
  width: theme.spacing(open ? 32 : 7),
  overflow: "auto",
  transition: open
    ? theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      })
    : theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
  "& .MuiPaper-root": {
    width: "inherit",
  },
}));

export default function Drawer() {
  const { isOpen, setIsOpen } = useDrawer();

  const { cliente } = useAppSelector((state) => state.cliente);

  return (
    <StyledDrawer
      variant={"temporary"}
      open={isOpen}
      onClose={() => setIsOpen(!isOpen)}
    >
      <UserAvatar name={cliente?.nome} />
      <DrawerMenu />
    </StyledDrawer>
  );
}
